import request from '../utils/Request';
import { Methods } from '../config';

const baseURL = 'taskgantt';

const taskGanttService = {
  getTask: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/task`,
      data,
    });
  },

  getProductions: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/productions`,
      data,
    });
  },

  getMachines: () => {
    return request({
      method: Methods.GET,
      resource: `${baseURL}/machines`,
    });
  },

  updateTask: (data, simpleTaskId) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/task/${encodeURIComponent(simpleTaskId)}`,
      data,
    });
  },

  updateProduction: (data) => {
    return request({
      method: Methods.PATCH,
      resource: `${baseURL}/production`,
      data,
    });
  },

  getActiveTimeByRange: (data) => {
    return request({
      method: Methods.POST,
      resource: `${baseURL}/activeTimes`,
      data,
    });
  },
};
export default taskGanttService;
